<template>
  <modal-confirm class="language-picker choice-picker" :active="modalActive" @modal-cancel="onCancel" @modal-confirm="onOkay">
    <h2>{{ $t('language-picker.label') }}</h2>
    <ol class="choices">
      <li v-for="(choice, key) in choices" :key="key">
        <input type="radio" :id="choice" :value="choice" v-model="active"/>
        <label :for="choice">{{ $t(`lang.label.${choice}`) }}</label>
      </li>
    </ol>
  </modal-confirm>
</template>

<script>
import PortalSettings from '@/models/PortalSettings';
import ModalMixin from '@/mixins/modal';
import ModalConfirm from '@/components/ModalConfirm';
import i18n  from '@/i18n';
import { loadLanguageAsync }  from '@/i18n';

export default {
  mixins: [ ModalMixin ],
  components: {
    ModalConfirm
  },

  data() {
    return {
      active: i18n.locale,

      modalStateKeys: ['active']
    };
  },

  computed: {
    choices() {
      // TODO - enable other languages when they become available
      // let activeLanguages = PortalSettings.get().lang.choices;
      let activeLanguages = ["en-US", "fr-FR", "fr-CA"];

      return activeLanguages;
    }
  },

  methods: {
    save() {
      loadLanguageAsync(this.active);
    }
  }
}
</script>
